import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';
import ArrowForward from '@material-ui/icons/ArrowForward';
import RocketIcon from '@material-ui/icons/FlightTakeoff';
import { withNamespaces } from 'react-i18next';
import logo from '../Sidebar/logo.png';
import './InstanceLoading.css';

const REDIRECT_SECONDS = 8;

/**
 * Pantalla de mudanza: el gimnasio ya está en la plataforma nueva y el socio
 * espera unos segundos, o entra ya, antes de ir al ingreso nuevo.
 */
class MaintenanceRedirect extends Component {
    state = { seconds: REDIRECT_SECONDS };

    componentDidMount() {
        this.remaining = REDIRECT_SECONDS;
        this.timer = setInterval(this.tick, 1000);
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    clearTimer = () => {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };

    tick = () => {
        this.remaining -= 1;
        if (this.remaining <= 0) {
            this.clearTimer();
            this.setState({ seconds: 0 });
            this.go();
            return;
        }
        this.setState({ seconds: this.remaining });
    };

    /**
     * Reemplaza la app vieja para que atrás no vuelva acá.
     */
    go = () => {
        this.clearTimer();
        window.location.replace(this.props.joinUrl);
    };

    continueNow = (event) => {
        event.preventDefault();
        this.go();
    };

    render() {
        const { t, joinUrl } = this.props;
        const { seconds } = this.state;
        const countdownKey = seconds === 1
            ? 'maintenance_redirect_countdown_one'
            : 'maintenance_redirect_countdown';

        return (
            <div className="canvas instanceError">
                <section className="instanceErrorCard migrationCard" aria-labelledby="migrationTitle">
                    <img src={logo} alt="PowerGym" className="instanceErrorBrand" />
                    <span className="instanceErrorIcon upgrade" aria-hidden="true">
                        <RocketIcon />
                    </span>
                    <h1 id="migrationTitle" className="instanceErrorTitle">
                        {t('maintenance_redirect_title')}
                    </h1>
                    <p className="instanceErrorLead">
                        {t('maintenance_redirect_lead')} {t('maintenance_redirect_taking')}
                    </p>
                    <p className="migrationStatus" role="status" aria-live="polite">
                        <span className="migrationSpinner" aria-hidden="true">
                            <CircularProgress size={16} color="inherit" />
                        </span>
                        <span>{t(countdownKey, { count: seconds })}</span>
                    </p>
                    <div className="instanceErrorActions">
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            size="large"
                            component="a"
                            href={joinUrl}
                            onClick={this.continueNow}
                            className="instanceErrorButton"
                        >
                            {t('maintenance_redirect_continue')}
                            <ArrowForward className="migrationButtonIcon" />
                        </Button>
                    </div>
                </section>
            </div>
        );
    }
}

MaintenanceRedirect.propTypes = {
    joinUrl: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
};

export default withNamespaces()(MaintenanceRedirect);
